import React, {useEffect, useState, useRef} from 'react'
import apiService from '../../../Services/apiServices'
import DataTable from '../../../PageComponents/UI/Tables/DataTable';
import helper from '../../../Services/helper';
import Select from "react-select"
import { Switch } from '@material-ui/core';
import ExcelExport from '../../../PageComponents/Excel/ExcelExport';
import Search from '../../../PageComponents/Search/Search';
import LoaderComponent from '../../../PageComponents/UI/Components/LoaderComponent';

const ReportAtkSaleBook = () => {
    const [data, setData] = useState([])
    const d = new Date();
    const searchObj = {CompanyBranch: 0, YEAR: d.getFullYear(), StartMonth: new Date().getMonth() + 1, EndMonth: new Date().getMonth() + 1}
    const [searchQuery, setSearchQuery] = useState(searchObj)
    const [reference, setReference] = useState(false);
    const [loader , setLoader] = useState(false);
    const [vat0, setVat0] = useState([])
    const [vat18, setVat18] = useState([])
    const [vat8, setVat8] = useState([])
    const [filledTable, setFilledTable] = useState(false)

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '28.59px',
            height: '28.59px',
            boxShadow: state.isFocused ? null : null,
        }),
    
        valueContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
            padding: '0 6px'
        }),
    
        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
        }),
    };

    const t = (key) => {
        return helper().translate(key);
    }

    const excelExportRef = useRef();

    const months = [
        {value: 1, label: t('JANUARY')},
        {value: 2, label: t('FEBRUARY')},
        {value: 3, label: t('MARCH')},
        {value: 4, label: t('APRILL')},
        {value: 5, label: t('MAY')},
        {value: 6, label: t('JUNE')},
        {value: 7, label: t('JULY')},
        {value: 8, label: t('AUGUST')},
        {value: 9, label: t('SEPTEMBER')},
        {value: 10, label: t('OCTOBER')},
        {value: 11, label: t('NOVEMBER')},
        {value: 12, label: t('DECEMBER')}
    ]
    const [years, setYears] = useState()

    // const vat0Headers = vat0.map((item, key) => ({
    //     key: `K${item.number}`, columnName: `K${item.number}`, type: "text"
    // }));
    const vat0Headers = [];
    let hasK10 = false;
    
    vat0.forEach(item => {
        if (parseInt(item?.number) > 10 && !hasK10) {
            vat0Headers.push({ key: 'K10', columnName: t('K10'), type: 'number' });
            hasK10 = true;
        } 
        vat0Headers.push({
            key: `K${item.number}`,
            columnName: t(`K${item.number}`),
            type: "text"
        });
    });
    
    
    const vat18Headers = vat18.map((item, key) => ({
        key: `K${item.number}`, columnName: `K${item.number}`, type: "text"
    }));
    const vat8Headers = vat8.map((item, key) => ({
        key: `K${item.number}`, columnName: `K${item.number}`, type: "text"
    }));

    const headers = [
        { key: 'Nr', columnName: t('NU') , dontShowMenu : true   },
        { key: 'Date', columnName: t('DATE') },
        !reference ? { key: 'InvoiceNo', columnName: t('INVOICE_NO') } : { key: 'Reference', columnName: t('REFERENCE') , type:"comment" },
        { key: 'CompanyName', columnName: t('COMPANY_NAME') , type:"text"},
        { key: 'FiscalNumber', columnName: t('FISCAL_NUMBER') , type:"text"},
        { key: 'VatNumber', columnName: t('VAT_NUMBER') },
        ...vat0Headers,
        // { key: 'K10', columnName: t('K10') , type: "number"},
        ...vat18Headers,
        { key: 'K1', columnName: t('K1') , type: "number"},
        ...vat8Headers,
        { key: 'K2', columnName: t('K2') , type: "number"},
        { key: 'K30', columnName: t('K30'), type: "number" }
    ];

    const getDataSaleVat = async () => {
        var params = `purchaseOrSale=${1}`;

        await apiService().query('getSaleOrPurchase', params)
            .then((response) => {
                if(response.success) {
                    let d = response.data;
                    setVat0(d.filter(f => f.vat === 0))
                    setVat18(d.filter(f => f.vat === 18))
                    setVat8(d.filter(f => f.vat === 8))
                    setFilledTable(true)
                }
            })
    }


    const fillYears = () => {
        let s = d.getFullYear() - 10
        let e = d.getFullYear()
        let years = []

        for (let index = s; index <= e; index++) { 
            let obj = {value: index, label: index}
            years.push(obj)
        }
        setYears(years)
    }


    const getData = () => {
        setLoader(true);
        var params = `CompanyBranch=${searchQuery.CompanyBranch}&YEAR=${searchQuery.YEAR}&StartMonth=${searchQuery.StartMonth}&EndMonth=${searchQuery.EndMonth}`;

        apiService().query('RptAtkSaleBookNew', params)
            .then((response) => {
                if(response.success) {
                    setLoader(false);
                    let array = response.data;
                    array.forEach(obj => {
                        // Iterate over each key-value pair in the object
                        Object.keys(obj).forEach(key => {
                          if (typeof obj[key] === 'number' && obj[key] % 1 !== 0) {
                            let decimalPart = obj[key].toString().split('.')[1];
                            if (decimalPart && decimalPart.length > 2) {
                              obj[key] = parseFloat(obj[key].toFixed(2));
                            }
                          }
                        });
                      });
                    setData(array)
                }
            })
    }

    const print = () => {
        window.open(`#/excel-print?CompanyBranch=${searchQuery.CompanyBranch}&YEAR=${searchQuery.YEAR}&StartMonth=${searchQuery.StartMonth}&EndMonth=${searchQuery.EndMonth}`, 'popUpWindow','height=1300,width="100%",left=100,top=100,right=100,bottom=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
    }

    const exportToExcel = () => {
        //let table = document.getElementById('table-to-xls-1').innerHTML;
        let fileName = helper().translate("ATK_SALE_BOOK")
        //return helper().exportToExcel(table, fileName)
        excelExportRef.current.exportToExcel(fileName)
    }

    const exportToExcel1 = () => {
        var table= document.getElementById('table-to-xls-1');
        var html = table.outerHTML;
        window.open('data:application/vnd.ms-excel,' + escape(html));
    }

    useEffect(() => {
        getData()
        fillYears()
        getDataSaleVat()
    }, [])

    return (
        <div>
            <div className="container-fluid px-2 mt-3">
                <Search search={false} excel={() => exportToExcel()} printClick={print} back="#/reportsMap/2"/>
                {/* <Search search={false} excel={exportToExcel} printClick={print}/> */}
                <div className="card border-left-primary shadow h-100 py-2">
                    <div className="card-body py-0">
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2 row">
                            <div className='w-100 d-md-flex d-lg-flex' >
                                <div className="col-md-3 col-lg-3 form-group">
                                    <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                    {helper().translate("FROM")}
                                    </label>
                                    <Select styles={selectStyles} value={months?.find(m=> m.value === searchQuery.StartMonth)} options={months} onChange={(e) => { setSearchQuery({...searchQuery, StartMonth: e.value })}} />
                                </div>
                                <div className="col-md-3 col-lg-3 form-group">
                                    <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                        {helper().translate("TO")}
                                    </label>
                                
                                    <Select styles={selectStyles} value={months?.find(m=> m.value === searchQuery.EndMonth)} options={months} onChange={(e) => { setSearchQuery({...searchQuery, EndMonth: e.value })}} />
                                </div>
                                <div className="col-md-3 col-lg-3 form-group">
                                    <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                    {helper().translate("YEAR")}
                                    </label>
                                
                                    <Select styles={selectStyles} value={years?.find(y=> y.value === searchQuery.YEAR)} options={years} onChange={(e) => { setSearchQuery({...searchQuery, YEAR: e.value })}} />
                                </div>
                                <div className="col-md-3 col-lg-3 form-group">
                                    <label className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                        {t('REFERENCE')}
                                    </label><br></br>
                                
                                    <Switch className="mt-0" color="primary" onChange={(e)=> setReference(e.target.checked)} checked={reference}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-auto">
                        <a className="searchbutton" onClick={getData}>
                            <i className="fas fa-search fa-2x text-dark" />
                        </a> 
                        </div>
                    </div>
                    </div>
                </div>
                <div className="card shadow mt-1">
                    <div className="card-header py-2">
                        <h6 className="m-0 font-weight-bold text-primary text-center">{helper().translate("ATK_SALE_BOOK")}</h6>
                    </div>
                    {loader && <LoaderComponent /> } 
                    {!loader && filledTable ? <DataTable data={data.length ? data : []} headers={headers} /> : ""}
                    <div className='d-none1'>
                        <div id="excelFile">
                            <ExcelExport data={data.length ? data : []} headers={headers} type={'sale'} ref={excelExportRef} hideContent={true} zeroToNull={true} />  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportAtkSaleBook

